import Vue from 'vue';
export const AmbientEventBus = new Vue();